<template>
  <div :id="localId"></div>
</template>

<script>
import mx_Core from './includes/mixins/zMixins'                  // Global & Local Mixins

export default {
  name: "j-chart-dropdown",
  mixins: [mx_Core],
  props: {
    id: String,

    // ### Necessaries for the Chart Controller ###
    Action: {
      type: Object,
      default: () => ({})
    },
    FilterValues: {
      type: Object,
      default: () => ({})
    },
    // ### ------------------------------------ ###
    
    // Chart Data
    Canvas: { type: Object, default: () => ({}) },
    Note: { type: Object, default: () => ({}) },

    // Database
    DataItems: { type: Array, default: () => ([]) },

    values: {
      type: Object,
      default: () => ({
        milestone: [],
        note: '',
      })
    },
    resource: String,
  },
  created() {
    this.localId = `${this.id || 'j-chart-dropdown'}__${this.safeId('')}`
  },
  mounted() {
    this.register(this.draw)
  },

  methods: {
    draw() {
      // Check all the necessary values are available
      if (!this.ready2draw) return

      this.clear()
      this.set_LocalValues()
      this.drawCanvas()
      this.drawChart()

      // 'complete' must be executed to finish the parent process.
      // It sends 'this.localId' & XmlString for some case to make 
      // displaying image easy.
      this.complete()
    },


  }
}
</script>